"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWidget = exports.ButtonType = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var InteractiveDom_1 = require("../../utils/InteractiveDom");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var ActivitySpinnerWidget_1 = require("../ActivitySpinnerWidget");
var ButtonWidget_1 = require("./ButtonWidget");
Object.defineProperty(exports, "ButtonType", { enumerable: true, get: function () { return ButtonWidget_1.ButtonType; } });
/* eslint-disable deprecation/deprecation */
var ButtonKindMap = Object.freeze((_a = {},
    _a[ButtonWidget_1.ButtonType.Destructive] = 'destructive',
    _a[ButtonWidget_1.ButtonType.Attention] = 'destructive',
    _a[ButtonWidget_1.ButtonType.Grey] = 'outline',
    _a[ButtonWidget_1.ButtonType.Primary] = 'primary',
    _a[ButtonWidget_1.ButtonType.Go] = 'primary',
    _a[ButtonWidget_1.ButtonType.Outline] = 'outline',
    _a[ButtonWidget_1.ButtonType.OutlineDark] = 'outlineDark',
    _a[ButtonWidget_1.ButtonType.LightOutline] = 'outlineDark',
    _a[ButtonWidget_1.ButtonType.OutlineGo] = 'primary',
    _a[ButtonWidget_1.ButtonType.OutlineAttention] = 'destructive',
    _a[ButtonWidget_1.ButtonType.Text] = 'lowEmphasis',
    _a[ButtonWidget_1.ButtonType.DarkText] = 'lowEmphasis',
    _a[ButtonWidget_1.ButtonType.DarkBoldText] = 'lowEmphasis',
    _a[ButtonWidget_1.ButtonType.Icon] = 'outline',
    _a[ButtonWidget_1.ButtonType.IconOutline] = 'outline',
    _a[ButtonWidget_1.ButtonType.LowEmphasisDark] = 'lowEmphasisDark',
    _a));
// these are legacy styles that we preserve for backward compatibility, but should not be used for new features
var IconButtonStyle = Object.freeze({
    alignItems: 'center',
    borderColor: 'transparent',
    boxSizing: 'border-box',
    color: TabStyles_1.TabStyles.Typography.Color.PrimaryLight,
    display: 'inline-flex',
    fontWeight: 'normal',
    height: 'auto',
    justifyContent: 'center',
    minHeight: 20,
    minWidth: 20,
    padding: 0,
    whiteSpace: 'nowrap',
});
var ButtonStyleOverrides = Object.freeze((_b = {},
    _b[ButtonWidget_1.ButtonType.Icon] = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, IconButtonStyle), { $nest: {
            '&:hover:enabled, &:focus-visible': { backgroundColor: TabStyles_1.TabStyles.Colors.F3, color: TabStyles_1.TabStyles.Typography.Color.Primary },
            '&&&:active': { backgroundColor: TabStyles_1.TabStyles.Colors.F5, color: TabStyles_1.TabStyles.Typography.Color.Primary },
            '&:disabled': { borderColor: 'transparent !important', opacity: TabStyles_1.TabStyles.Opacity.Disabled },
        } })),
    _b[ButtonWidget_1.ButtonType.IconOutline] = TypeStyle.style(tslib_1.__assign(tslib_1.__assign({}, IconButtonStyle), { border: 'none', position: 'relative', $nest: {
            '&:hover:enabled, &:focus-visible, &&&:active': { backgroundColor: 'transparent' },
            '&:focus-visible::after': {
                content: "\"\"",
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
                border: "1px solid " + TabStyles_1.TabStyles.Colors.Focus,
                borderRadius: 2,
                pointerEvents: 'none',
            },
            '&:disabled': { borderColor: 'transparent !important', opacity: TabStyles_1.TabStyles.Opacity.Disabled },
        } })),
    _b));
/* eslint-enable deprecation/deprecation */
var ButtonShowSpinnerStyleName = TypeStyle.style({
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    pointerEvents: 'none',
});
var DarkButtonKinds = Object.freeze(['primary', 'destructive', 'outlineDark', 'lowEmphasisDark']);
var ButtonSpinner = function (props) {
    return React.createElement(ActivitySpinnerWidget_1.ActivitySpinnerWidget, { onDarkBackground: DarkButtonKinds.indexOf(props.buttonKind) > -1, spinnerSize: ActivitySpinnerWidget_1.ActivitySpinnerSize.Small, style: { lineHeight: 0.5, position: 'absolute' }, testId: props.testId });
};
var ButtonWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonWidget, _super);
    function ButtonWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { active: false, focus: false, hover: false };
        _this.handleActive = function (active) { return _this.setState({ active: active }); };
        _this.handleFocus = function (focus) { return _this.setState({ focus: focus }); };
        _this.handleHover = function (hover) { return _this.setState({ hover: hover }); };
        /* eslint-disable deprecation/deprecation */
        _this.handleClick = function (e) {
            if (_this.props.disabled || _this.props.showSpinner) {
                return;
            }
            else if (_this.props.handleClick) {
                _this.props.handleClick(e);
            }
            else if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        return _this;
    }
    ButtonWidget.getDerivedStateFromProps = function (props) {
        if (props.disabled) {
            return { active: false, focus: false, hover: false };
        }
        return null;
    };
    /* eslint-enable deprecation/deprecation */
    ButtonWidget.prototype.render = function () {
        var _a;
        // eslint-disable-next-line max-len, deprecation/deprecation
        var _b = this.props, ariaDisabled = _b["aria-disabled"], buttonRef = _b.buttonRef, buttonType = _b.buttonType, className = _b.className, disabled = _b.disabled, disableTabAccessibility = _b.disableTabAccessibility, getContent = _b.getContent, handleClick = _b.handleClick, role = _b.role, selected = _b.selected, showSpinner = _b.showSpinner, tabIndex = _b.tabIndex, testId = _b.testId, rest = tslib_1.__rest(_b, ['aria-disabled', "buttonRef", "buttonType", "className", "disabled", "disableTabAccessibility", "getContent", "handleClick", "role", "selected", "showSpinner", "tabIndex", "testId"]);
        var kind = ButtonKindMap[buttonType];
        var buttonContent = (_a = getContent === null || getContent === void 0 ? void 0 : getContent(tslib_1.__assign(tslib_1.__assign({}, this.state), { disabled: disabled, selected: selected }))) !== null && _a !== void 0 ? _a : rest.children;
        var children = !showSpinner ?
            buttonContent :
            React.createElement(React.Fragment, null,
                showSpinner && React.createElement(ButtonSpinner, { testId: testId, buttonKind: kind }),
                React.createElement("div", { style: { visibility: 'hidden' }, children: buttonContent }));
        var button = React.createElement(TableauUI.Button, tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut, { "aria-checked": role === 'radio' ? selected : undefined, "aria-disabled": showSpinner || ariaDisabled, "aria-pressed": role === 'radio' ? undefined : selected, "data-tb-test-id": Declarative_1.makeTestId(testId, 'Button') }, rest, { children: children, className: TypeStyle.classes(ButtonStyleOverrides[buttonType], showSpinner && ButtonShowSpinnerStyleName, className), disabled: showSpinner ? undefined : disabled, kind: kind, onClick: this.handleClick, ref: buttonRef, role: role, tabIndex: disabled ? undefined : (this.props.disableTabAccessibility ? -1 : (tabIndex || 0)) }));
        if (getContent) {
            return React.createElement(InteractiveDom_1.InteractiveDomWrapper, { children: button, disabled: disabled, handleActive: this.handleActive, handleFocus: this.handleFocus, handleHover: this.handleHover });
        }
        else {
            return button;
        }
    };
    ButtonWidget.defaultProps = { buttonType: ButtonWidget_1.ButtonType.Outline, density: 'low' };
    return ButtonWidget;
}(React.Component));
exports.ButtonWidget = ButtonWidget;
//# sourceMappingURL=ButtonWidgetShim.js.map